/**
 * Cómo se ve lo que el bot escribió (GKTIBO-114).
 *
 * ## El reporte
 *
 * El PO, 2026-09-23: «**Sobre la ubicación:** Nuestras sedes están en
 * **Barranquilla**». Los asteriscos crudos, en cada respuesta.
 *
 * En Telegram y WhatsApp eso se convierte desde GKTIBO-93. La pantalla de
 * prueba no pasaba por ahí, y **la pantalla existe para que el dueño juzgue a
 * su bot**: si lo que ve no se parece a lo que verá su cliente, lo juzga mal
 * en las dos direcciones.
 *
 * ## Por qué NO se usa `dangerouslySetInnerHTML`
 *
 * El texto del bot es contenido **no confiable**: sale de un modelo que leyó
 * el sitio web del tenant. Si alguien mete un script en su web, termina en el
 * `.md` y de ahí en esta pantalla. Acá se arman nodos de React, así que lo que
 * venga escrito como HTML se muestra como texto y no se ejecuta.
 *
 * ## Por qué es markdown básico y no el formato exacto del canal
 *
 * El formato es POR canal —Telegram usa HTML, WhatsApp asteriscos simples— así
 * que no hay UNA forma correcta. Esto renderiza lo que los dos tienen en
 * común: negrita, viñetas y párrafos. Mostrarlo exactamente como lo vería el
 * canal conectado es mejor y es su propio trabajo.
 */

const NEGRITA = /\*\*([^*\n]+?)\*\*/g;

/** Parte una línea en texto y negritas, sin tocar los asteriscos sueltos. */
function conNegritas(linea: string, clave: string) {
  const partes: Array<string | { fuerte: string }> = [];
  let ultimo = 0;

  NEGRITA.lastIndex = 0;
  let m = NEGRITA.exec(linea);
  while (m !== null) {
    if (m.index > ultimo) partes.push(linea.slice(ultimo, m.index));
    partes.push({ fuerte: m[1] });
    ultimo = m.index + m[0].length;
    m = NEGRITA.exec(linea);
  }
  if (ultimo < linea.length) partes.push(linea.slice(ultimo));

  return partes.map((parte, i) =>
    typeof parte === 'string' ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: el índice ES la posición
      <span key={`${clave}-${i}`}>{parte}</span>
    ) : (
      // biome-ignore lint/suspicious/noArrayIndexKey: el índice ES la posición
      <strong key={`${clave}-${i}`}>{parte.fuerte}</strong>
    ),
  );
}

const ES_VINETA = /^\s*[-*•]\s+/;

export interface TextoDelBotProps {
  texto: string;
}

export function TextoDelBot({ texto }: TextoDelBotProps) {
  const lineas = texto.split('\n');
  const bloques: Array<{ tipo: 'parrafo' | 'lista'; lineas: string[] }> = [];

  for (const linea of lineas) {
    if (!linea.trim()) continue;
    const esVineta = ES_VINETA.test(linea);
    const ultimo = bloques[bloques.length - 1];

    if (esVineta && ultimo?.tipo === 'lista') {
      ultimo.lineas.push(linea.replace(ES_VINETA, ''));
    } else if (esVineta) {
      bloques.push({ tipo: 'lista', lineas: [linea.replace(ES_VINETA, '')] });
    } else {
      bloques.push({ tipo: 'parrafo', lineas: [linea] });
    }
  }

  return (
    <>
      {bloques.map((bloque, i) =>
        bloque.tipo === 'lista' ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: el índice ES la posición
          <ul key={`b${i}`} className="texto-del-bot-lista">
            {bloque.lineas.map((linea, j) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: el índice ES la posición
              <li key={`b${i}-${j}`}>{conNegritas(linea, `b${i}-${j}`)}</li>
            ))}
          </ul>
        ) : (
          // biome-ignore lint/suspicious/noArrayIndexKey: el índice ES la posición
          <p key={`b${i}`}>{conNegritas(bloque.lineas[0], `b${i}`)}</p>
        ),
      )}
    </>
  );
}
